import store from "@/modules/campos_novos/store";
import routes from "@/modules/campos_novos/routes";

export default {
  install(Vue, { store: rootStore, router }) {
    router.addRoutes(routes);
    rootStore.registerModule("campos_novos", store);
  }
};
